@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Michigan</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div class="axis-form-group _mt-medium"
      [ngClass]="{
              'has-axis-required':
               reactiveForm.get(controls[0].formControlName)?.value === '' ||
              reactiveForm.get(controls[0].formControlName)?.value === null,
               'has-axis-error':
                  reactiveForm.get(controls[0].formControlName)?.touched &&
                  reactiveForm.get(controls[0].formControlName)?.invalid,
            }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper
            formControlName="{{ controls[0].formControlName }}">
            <p class="axis-h5">
              {{ controls[0].label }}
              <span
                aria-hidden="true"
                class="axis-required-indicator"
                >*</span
              >
            </p>
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
              }
            }
        }
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Michigan</h2>
    @if(baseRules?.rejectSelection === 'Yes') {
      <div class="axis-form-group">
        <label class="axis-control-label">{{ textValues?.RejectOption_Text }}</label>
      </div>
    }
  }
